import { createContext } from 'reka-ui'
import type { AccessRole } from '@gat-ship/types'
import type { AccessRolesCollectionService } from '@gat-ship/types/injection-keys'

export interface ShowAddAccessRoleDialogParams {
  accessRole?: AccessRole
}

export interface AccessRolesCollectionProviderContext {
  dataSource: AccessRolesCollectionService
  modals: {
    showAddAccessRole: (params: ShowAddAccessRoleDialogParams) => void
  }
}

export const [useAccessRolesCollectionProvider, provideAccessRolesCollection] =
  createContext<AccessRolesCollectionProviderContext>(
    'access-roles-collection-provider'
  )
